import React from 'react';
import { InfoIcon, WifiIcon, BarChart2Icon, ShieldIcon, ClockIcon, TruckIcon } from 'lucide-react';
export const AddOns = ({
  addOns,
  setAddOns,
  addOnPrices,
  formatPrice
}) => {
  const handleToggleAddOn = key => {
    setAddOns({
      ...addOns,
      [key]: !addOns[key]
    });
  };
  const addOnDetails = [{
    key: 'wifiThermostats',
    title: 'WiFi-termostater i alle zoner',
    description: 'Styr dit varmesystem via smartphone eller tablet',
    icon: <WifiIcon className="h-5 w-5 text-gray-400" data-id="element-15" />,
    price: addOnPrices.wifiThermostats
  }, {
    key: 'energyMonitoring',
    title: 'Energiovervågning / CTS-integration',
    description: 'Detaljeret indsigt i dit energiforbrug',
    icon: <BarChart2Icon className="h-5 w-5 text-gray-400" data-id="element-16" />,
    price: addOnPrices.energyMonitoring
  }, {
    key: 'serviceAgreement',
    title: 'Serviceaftale 24 mdr.',
    description: 'Regelmæssig vedligeholdelse og support',
    icon: <ShieldIcon className="h-5 w-5 text-gray-400" data-id="element-17" />,
    price: addOnPrices.serviceAgreement
  }, {
    key: 'extendedWarranty',
    title: 'Udvidet garanti 5 år',
    description: 'Forlænget tryghed og beskyttelse af din investering',
    icon: <ClockIcon className="h-5 w-5 text-gray-400" data-id="element-18" />,
    price: addOnPrices.extendedWarranty
  }, {
    key: 'expressDelivery',
    title: 'Hurtig levering / ekspresfragt',
    description: 'Få din løsning leveret hurtigere',
    icon: <TruckIcon className="h-5 w-5 text-gray-400" data-id="element-19" />,
    price: addOnPrices.expressDelivery
  }];
  return <section className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-20">
      <div className="p-6" data-id="element-21">
        <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-22">
          Tilvalg (opsalg)
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-23">
          {addOnDetails.map(addon => <div key={addon.key} className={`border rounded-lg p-4 transition-colors ${addOns[addon.key] ? 'border-red-500 bg-red-50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-24">
              <div className="flex justify-between" data-id="element-25">
                <div className="flex items-center gap-3" data-id="element-26">
                  {addon.icon}
                  <h3 className="font-medium text-gray-900" data-id="element-27">{addon.title}</h3>
                </div>
                <div className="relative inline-block w-10 align-middle select-none" data-id="element-28">
                  <input type="checkbox" name={addon.key} id={addon.key} checked={addOns[addon.key]} onChange={() => handleToggleAddOn(addon.key)} className="sr-only" data-id="element-29" />
                  <label htmlFor={addon.key} className={`block overflow-hidden h-6 rounded-full cursor-pointer transition-colors ${addOns[addon.key] ? 'bg-red-500' : 'bg-gray-300'}`} data-id="element-30">
                    <span className={`block h-6 w-6 rounded-full bg-white shadow transform transition-transform ${addOns[addon.key] ? 'translate-x-4' : 'translate-x-0'}`} data-id="element-31" />
                  </label>
                </div>
              </div>
              <p className="mt-2 text-sm text-gray-500" data-id="element-32">{addon.description}</p>
              <div className="mt-3 flex justify-between items-center" data-id="element-33">
                <span className="text-sm font-medium text-gray-900" data-id="element-34">
                  + {formatPrice(addon.price)}
                </span>
                <button className="text-xs text-gray-500 flex items-center gap-1 hover:text-gray-700" title="Mere information" data-id="element-35">
                  <InfoIcon className="h-3 w-3" data-id="element-36" />
                  Info
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};